module.exports = __webpack_public_path__ + "static/media/slide-soffit-fascia.6beb4dfc.jpg";